// removed by extract-text-webpack-plugin
module.exports = {"meta-nav":"meta-nav--3bldg","meta-link":"meta-link--ioS2_","lang-select":"lang-select--FR7d8","lang-list":"lang-list--1Jnia","is-active":"is-active--sr9AZ","arrow-icon":"arrow-icon--1R8Nh"};


//////////////////
// WEBPACK FOOTER
// ./client/components/meta-nav/meta-nav.scss
// module id = 474
// module chunks = 0